import Vue from 'vue';
import VueI18n from 'vue-i18n';

// register i18n module
Vue.use(VueI18n);

let i18n_FORMATS = {
    // Establecemos el "locale" por defecto, en caso de no encontrar una definición en el lenguaje
    // que el usuario seleccione
    fallbackLocale: 'ESP',
    // Establecemos el locale actual
    locale: 'ESP',
    silentTranslationWarn: true,
    // Definiciones para el locale ESP (Español México)
    'ESP': {
        // Definición del formato de moneda
        currency: {
            style: 'currency',
            currency: 'MXN',
            currencyDisplay: 'symbol'
        },
        // Definición del formato de enteros
        integer: {
            style: 'decimal',
            currency: 'MXN',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        },
        // Definición del formato de números decimales
        decimal: {
            style: 'decimal',
            currency: 'MXN',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    },
    // Definiciones para el locale en-US (Inglés EU)
    'en-US': {
        // Definición del formato de moneda
        currency: {
            style: 'currency',
            currency: 'USD',
            currencyDisplay: 'symbol'
        },
        // Definición del formato de enteros
        integer: {
            style: 'decimal',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        },
        // Definición del formato de números decimales
        decimal: {
            style: 'decimal',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    }
}

const i18n = new VueI18n(i18n_FORMATS);

export default i18n;